import * as z from 'zod';
import { isoDateTimeToAppTime } from '../base-codecs';
import { EntityId } from '../base-schemas';
// Mirrors ReservationEmailType on the server
export const ReservationEmailType = z.enum([
    'reservation_confirmation',
    'reservation_checkin_confirmation',
    'reservation_pickup_reminder',
    'reservation_checkout_reminder'
]);
// Mirrors SentEmailStatus on the server
export const SentEmailStatus = z.enum(['draft', 'sent', 'delivered', 'read', 'failed', 'complaint']);
/**
 * An email sent for a reservation or one of its items. Shaped so the shared
 * email timeline can render it.
 */
export const ReservationSentEmail = z.object({
    id: EntityId,
    // Null for a type the server does not know about
    email_type: ReservationEmailType.nullable(),
    title: z.string().nullable(),
    recipient_email: z.string().nullable(),
    status: SentEmailStatus,
    sent_at: isoDateTimeToAppTime.nullable(),
    opened_at: isoDateTimeToAppTime.nullable(),
    // Null when the email belongs to the whole reservation
    reservation_item_id: EntityId.nullable()
});
